import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppErrorService, ResolvedAppError } from './app-error.service';

@Injectable({ providedIn: 'root' })
export class ErrorBannerService {
  private readonly _errors$ = new BehaviorSubject<string[]>([]);
  private readonly _suppressed$ = new BehaviorSubject<boolean>(false);
  readonly errors$ = this._errors$.asObservable();
  readonly suppressed$ = this._suppressed$.asObservable();

  constructor(private appErrorService: AppErrorService) {}

  show(messages: string | string[]) {
    const list = Array.isArray(messages) ? messages : [messages];
    this._errors$.next(list.filter(Boolean));
  }

  showCode(codes: string | string[]) {
    const list = Array.isArray(codes) ? codes : [codes];
    this.show(
      list.map((code) => this.appErrorService.getKnownMessage(code))
    );
  }

  showError(error: unknown): ResolvedAppError {
    const resolved = this.appErrorService.resolve(error);
    this.show(resolved.message);
    return resolved;
  }

  remove(index: number) {
    const current = this._errors$.value;
    if (index < 0 || index >= current.length) {
      return;
    }
    const next = [...current];
    next.splice(index, 1);
    this._errors$.next(next);
  }

  clear() {
    this._errors$.next([]);
  }

  setSuppressed(suppressed: boolean): void {
    this._suppressed$.next(!!suppressed);
  }
}
